var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartMixedRightCircleDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9134 8.27148L28.2572 14.1621L29.3333 15.125L28.2572 16.1445L21.9134 22.0352L20.8939 22.9414L19.0247 20.959L20.0443 20.0527L23.8392 16.4844H10.7552H9.39584V13.7656H10.7552H23.8392L20.0443 10.2539L19.0247 9.34766L20.8939 7.30859L21.9134 8.27148ZM3.05209 15.125C3.05209 21.6387 8.31967 26.9062 14.8333 26.9062H16.1927V29.625H14.8333C6.79037 29.625 0.333344 23.168 0.333344 15.125C0.333344 7.13867 6.79037 0.625 14.8333 0.625H16.1927V3.34375H14.8333C8.31967 3.34375 3.05209 8.66797 3.05209 15.125Z",
    fill: "#DA5252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartMixedRightCircleDollar);
export default __webpack_public_path__ + "static/media/chart-mixed-right-circle-dollar.5b0197c5628d7f6669ccef99cb0138c7.svg";
export { ForwardRef as ReactComponent };